export default {
    computed: {
        isAdmin () {
            return this.roles.indexOf(this.ROLE_ADMIN) >= 0;
        },
        isInspector () {
            return this.roles.indexOf(this.ROLE_INSPECTOR) >= 0;
        },
        isLeadingAdmin () {
            // admin is highest order role
            return this.isAdmin;
        },
        isLeadingInspector () {
            // inspector is low-order role
            return this.isInspector && !this.isAdmin;
        }
    },
    created () {
        let self = this;

        // Not ready, or changes
        this.$store.subscribe((mutation, state) => {
            // console.log(mutation);

            self.roles = state.auth.roles;
        });

        // Ready
        if (this.$store.state.auth) {
            this.roles = this.$store.state.auth.roles;
        }
    },
    data () {
        return {
            roles: [],
            ROLE_ADMIN: 'admin',
            ROLE_INSPECTOR: 'inspector'
        };
    }
};



// WEBPACK FOOTER //
// ./src/mixins/role-mixins.js